import tasks from './tasks';
// import taskResponses from './task-responses';

const tasksActions = {
  ...tasks,
  // ...taskResponses,
};

export default tasksActions;
